import { FC, ReactNode } from 'react';
import styles from './styles.module.css';
import Footer from '../Footer';
import logo from '../../../assets/images/green-logo.svg';
import { Link } from 'react-router-dom';

type Props = {
  children?: ReactNode;
};

/**
 * プライバシーポリシー、利用規約などテキストを中心としたドキュメントを表示する
 */
const TextDocument: FC<Props> = ({ children }) => {
  return (
    <div className={styles.host}>
      <div className={styles.logo}>
        <Link to={'/login'}>
          <img width={135} height={38} src={logo} />
        </Link>
      </div>
      <div className={styles.document}>{children}</div>
      <div className={styles.footer}>
        <Link to={'/login'} className={styles.footerLogo}>
          <img width={195} height={55} src={logo} />
        </Link>
        <Footer />
      </div>
    </div>
  );
};
export default TextDocument;

export { default as Footnote } from './Footnote';
export { default as Header } from './Header';
export { default as Link } from './Link';
export { default as Paragraph } from './Paragraph';
export { default as Title } from './Title';
